/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NegativeReportType } from './negativeReportType';
import { PositiveReportType } from './positiveReportType';


export interface ReportType { 
    positiveReport?: PositiveReportType;
    negativeReport?: NegativeReportType;
}

